export const GET_LAYOUT_WIDTH = 'GET_LAYOUT_WIDTH';
export const SET_LAYOUT_WIDTH = 'SET_LAYOUT_WIDTH';

export const SET_AUTH_NAVIGATOR_CATEGORIES = 'SET_AUTH_NAVIGATOR_CATEGORIES_LIST';
export const SET_SETTINGS_CATEGORIES = 'SET_SETTINGS_CATEGORIES_LIST';